export default {
	overview: {
		en: 'Overview',
		nl: 'Overzicht',
	},
};
